import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "environments/environment";
import {AllergenGroupRequestDto, DisplayedAllergenGroup} from "app/models/menu.model";
import {firstValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AllergenGroupService {

  private requestPath = `${environment.posBaseUrl}/api/front/allergen-group`;

  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private http: HttpClient,
  ) { }

  public async create(menuId: string, requestDto: AllergenGroupRequestDto) : Promise<DisplayedAllergenGroup>{
    try{
      return await firstValueFrom(
        this.http.post<DisplayedAllergenGroup>(
          this.requestPath + "/" + menuId,
          requestDto,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  public async update(allergenGroupId: string, requestDto: AllergenGroupRequestDto) : Promise<DisplayedAllergenGroup>{
    try {
      return await firstValueFrom(
        this.http.put<DisplayedAllergenGroup>(
          this.requestPath + "/" + allergenGroupId,
          requestDto,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  public async delete(allergenGroupId: string) : Promise<null> {
    try{
      return await firstValueFrom(this.http.delete<null>(
        this.requestPath + "/" + allergenGroupId,
      ))
    }
    catch(exception){
      // TODO: какая-то ошибка
      console.log('exception', exception);
      return exception;
    }
  }
}
